import Overlay from '../classes/overlay';

window.searchInput = $('.dgwt-wcas-search-input');

$('.search-form-backdrop').on('click', function () {
  $('.dgwt-wcas-search-focused .dgwt-wcas-search-input:focus')
    .trigger('focus')
    .trigger('blur');

  if ($('.hb-search-overlay.is-open').length) {
    $('[data-action="search-overlay"]').trigger('click');
  }
});

new Overlay({
  toggle: '[data-action="search-overlay"]',
  selector: '.hb-search-overlay',
});

$('[data-action="search-overlay"]').on('open-overlay', function () {
  $('body').addClass('dgwt-wcas-open');
  setTimeout(() => {
    $('.hb-search-overlay input').focus();
  }, 300);
});
